import {
  withFormsy,
} from 'formsy-react';

import InputYesNoView from './InputYesNoView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputYesNoView);

const Component = InputComponent;

export default Component;
